<div class="bg-gray-100 active:bg-gray-200 rounded-lg p-3 mb-4 shadow-xs flex items-center transition-all duration-150">
  <ng-content></ng-content>
</div>
